import { render, staticRenderFns } from "./SupplyOrdersPendingReport.vue?vue&type=template&id=380fb46d&"
import script from "./SupplyOrdersPendingReport.vue?vue&type=script&lang=js&"
export * from "./SupplyOrdersPendingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports